import { defineAsyncComponent } from 'vue'

export const ModalPayment = defineAsyncComponent(() => import('../ModalPayment/ModalPayment.vue'))
